import React from 'react'
import {Modal as ModalBase} from 'bootstrap'
import {ModalInstanceContext} from 'context'
import {useEffect, useRef, useState, useContext} from 'hooks'

export function Modal({children, size}: {children?: any; size?: string})
{
  const {isOpen, close, unmount} = useContext(ModalInstanceContext)
  const modalRef = useRef<any>(undefined)
  const [modal, setModal] = useState<any>()

  useEffect(() => {
    const el = modalRef.current
    if (!el) {
      return
    }
    const instance = new ModalBase(el)
    el.addEventListener('hidden.bs.modal', close)
    setModal(instance)

    // Dispose the instance we created in *this* effect run (not a ref to state,
    // which is still undefined when StrictMode's dev mount→unmount→mount fires
    // the cleanup before setModal commits).
    return () => {
      el.removeEventListener('hidden.bs.modal', close)
      instance.dispose()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    let timer: any
    if (modal) {
      if (isOpen) {
        modal.show()
      } else {
        modal.hide()
        timer = setTimeout(unmount, 500)
      }
    }
    return () => timer && clearTimeout(timer)
  }, [modal, isOpen, unmount])

  return (
    <div ref={modalRef} className="modal fade" tabIndex={-1}>
      <div className={`modal-dialog modal-dialog-scrollable modal-fullscreen-sm-down${size ? ` modal-${size}` : ''}`}>
        <div className="modal-content">
          {/* Always-present close affordance: modals are full-screen on mobile, so
              without an X they can't be dismissed. Bootstrap's data-bs-dismiss fires
              `hidden.bs.modal`, which the effect above maps to `close`. */}
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            style={{
              position: 'absolute',
              top: '0.75rem',
              right: '0.75rem',
              zIndex: 10,
              // Subtle white disc so the dark glyph stays legible over media
              // (e.g. the post-detail image), barely visible on white bodies.
              padding: '0.6rem',
              backgroundColor: 'rgba(255,255,255,0.85)',
              borderRadius: '50%',
              boxShadow: '0 0 0 1px rgba(0,0,0,0.05)',
            }}
          />
          {children}
        </div>
      </div>
    </div>
  )
}
